// Copyright 2017-2022 @polkadot/util-crypto authors & contributors
// SPDX-License-Identifier: Apache-2.0

// Don't use a export * since we don't want to duplicate packageInfo
export { allNetworks, availableNetworks, selectableNetworks } from '@polkadot/networks';